// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  WORKER_CONFIG_SET_DISPLAYED_USER,
} from './constants';

export function setDisplayedUser(id) {
  return {
    type: WORKER_CONFIG_SET_DISPLAYED_USER,
    data: {id: id}
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case WORKER_CONFIG_SET_DISPLAYED_USER:
      return {
        ...state,
        displayedUser: action.data
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/worker-config/redux/setDisplayedUser.js